import { getCurrentCanvas, getSelectedBrandingArea, setLoader } from "../../../helpers/helper";
import { qtyProxy } from "../../../..";
import { hideLogoContainerHandler, initUploadLogoButton } from "./uploadLogoController";
import { textEditorInitial, updateHeaderProductNameAndSku } from "../productConfigurationController";
import { initCanvas } from "../components";
import { clickStepBtnHandler } from "./tabController";
import { hideTextEditorHandler } from "../../productDetail/textController";

function updateCanvasVisibility(selectedIndex) {
  const canvasWrappers = document.getElementsByClassName("canvas-editor-wrapper");

  for (let i = 0; i < canvasWrappers.length; i++) {
    canvasWrappers[i].classList.add("hide");
    canvasWrappers[i].classList.remove("show");
    if (i == selectedIndex) {
      canvasWrappers[i].classList.remove("hide");
      canvasWrappers[i].classList.add("show");
    }
  }
}

export const updateCanvasStatesAndSelection = () => {
  let currentObject = getCurrentCanvas()?.getObjects()?.[getCurrentCanvas()?.getObjects()?.length - 1];
  if (currentObject?.id === "drawableArea") {
    hideTextEditorHandler();
    hideLogoContainerHandler();
    clickStepBtnHandler(0);
    return;
  }
  getCurrentCanvas().setActiveObject(currentObject);
  getCurrentCanvas().renderAll();
  getCurrentCanvas()?.fire("selection:updated", {
    selected: [currentObject],
    target: currentObject,
  });
};

export const addPositionOptionsHandler = (printAreas, isEdit) => {
  setLoader(true);
  const techniqueDropdown = document.getElementById("print-area-selection");
  const editPrintSelectionTitle = document.getElementById("print-area-selection-edit");
  const selectionDropdownLogo = document.getElementById("selection-dropdown-logo");
  const countShowElement = document.getElementById("show-current-position");
  const technicTitle = document.getElementById("technic-title");
  const selectElement = document.getElementById("print-area-selection");
  const changeBtnElements = document.querySelectorAll(".change-current-position");
  const brandingOptionSlider = document.getElementById("branding-option-slider");

  if (isEdit) {
    brandingOptionSlider.style.visibility = "hidden";
    techniqueDropdown.style.display = "none";
    selectionDropdownLogo.style.display = "none";
    editPrintSelectionTitle.style.display = "block";
    editPrintSelectionTitle.innerText = `${printAreas?.[0]?.brandingAreas[0]?.availableTechniques?.[0]?.techniqueName}, ${printAreas?.[0]?.brandingAreas[0]?.availableTechniques?.[0]?.currentTechnique}`;
    technicTitle.innerHTML = `${printAreas?.[0]?.brandingAreas[0]?.availableTechniques?.[0]?.techniqueName}, ${printAreas?.[0]?.brandingAreas[0]?.availableTechniques?.[0]?.currentTechnique}`;
    setLoader(false);
    return;
  }
  editPrintSelectionTitle.style.display = "none";
  // Populate the dropdown with technique names
  printAreas?.forEach((technique, index) => {
    let option = document.createElement("option");
    option.value = index;
    option.text = `${technique?.brandingAreas[0]?.availableTechniques?.[0]?.techniqueName}, ${technique?.brandingAreas[0]?.availableTechniques?.[0]?.currentTechnique}`;
    techniqueDropdown?.appendChild(option);
    setLoader(false);
  });

  countShowElement.innerHTML = `${+qtyProxy["selectedPositionIndex"] + 1}/${printAreas?.length}`;
  technicTitle.innerHTML = `${printAreas?.[0]?.brandingAreas[0]?.availableTechniques?.[0]?.techniqueName}, ${printAreas?.[0]?.brandingAreas[0]?.availableTechniques?.[0]?.currentTechnique}`;

  const positionDropDownEventBinding = async () => {
    setLoader(true);
    const selectedValue = (selectElement as HTMLInputElement).value;
    qtyProxy["previousSelectedPositionIndex"] = qtyProxy["selectedPositionIndex"];
    qtyProxy["selectedPositionIndex"] = selectedValue;
    updateCanvasVisibility(selectedValue);
    updateHeaderProductNameAndSku();
    await initCanvas(getSelectedBrandingArea(), qtyProxy["selectedPositionIndex"]);
    updateCanvasStatesAndSelection();
    textEditorInitial();
    initUploadLogoButton();
    setLoader(false);
  };

  selectElement.addEventListener("change", function () {
    positionDropDownEventBinding().catch((error) => {
      console.error("Error during selection change:", error);
    });
  });

  async function handlePositionChange(btn) {
    setLoader(true);
    const summaryElement = document.getElementById("logo-summary-wrapper");
    let currentIndex = qtyProxy["selectedPositionIndex"];
    let nextIndex = currentIndex;

    if (btn.classList.contains("prev-current-position")) {
      nextIndex--;
    }
    if (btn.classList.contains("next-current-position")) {
      nextIndex++;
    }

    if (nextIndex < 0 || nextIndex >= printAreas.length) {
      setLoader(false);
      return;
    }
    qtyProxy["previousSelectedPositionIndex"] = currentIndex;
    qtyProxy["selectedPositionIndex"] = nextIndex;
    summaryElement.classList.remove("hidden");
    updateCanvasVisibility(nextIndex);
    updateHeaderProductNameAndSku();
    await initCanvas(getSelectedBrandingArea(), qtyProxy["selectedPositionIndex"]);
    updateCanvasStatesAndSelection();
    textEditorInitial();
    initUploadLogoButton();
    countShowElement.innerHTML = `${+qtyProxy["selectedPositionIndex"] + 1}/${printAreas?.length}`;
    technicTitle.innerHTML = `${printAreas?.[+qtyProxy["selectedPositionIndex"]]?.brandingAreas[0]?.availableTechniques?.[0]?.techniqueName}, ${
      printAreas?.[+qtyProxy["selectedPositionIndex"]]?.brandingAreas[0]?.availableTechniques?.[0]?.currentTechnique
    }`;
    setLoader(false);
  }
  changeBtnElements.forEach((btn) => {
    btn.addEventListener("click", function () {
      handlePositionChange(btn).catch((error) => {
        console.error("Error during selection change:", error);
      });
    });
  });
};

export const initializeCanvasesForPositions = (printAreas) => {
  qtyProxy["selectedPositionIndex"] = 0;
  qtyProxy["previousSelectedPositionIndex"] = 0;
  if (!qtyProxy["canvasListForPosition"]) {
    qtyProxy["canvasListForPosition"] = []; // Initialize as an empty array if not already initialized
  }

  printAreas?.forEach((technique, index) => {
    qtyProxy["canvasListForPosition"][index] = {
      ...qtyProxy["canvasListForPosition"][index],
      selectedTechnique: technique?.brandingAreas[0]?.availableTechniques?.[0],
      selectedBrandingArea: technique?.brandingAreas?.[0],
    };
  });
};

export const updateCanvasWithAreaPosition = (index: number, properties: { [key: string]: any }) => {
  qtyProxy["canvasListForPosition"][index] = {
    ...qtyProxy["canvasListForPosition"][index],
    ...properties,
  };
};
